import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=f9c618ec&scoped=true&"
import script from "./SerialNumber.vue?vue&type=script&lang=js&"
export * from "./SerialNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c618ec",
  null
  
)

export default component.exports